import { useMemo } from 'react';
import PropTypes from 'prop-types';

import BreakdownSummary from '#/modules/infra/dashboard/components/BreakdownSummary';
import { formatAmount } from '#/modules/infra/dashboard/helper/dashboardChartTheme';
import { AMOUNT_KEY_COLOR_INDEX, AMOUNT_KEY_LABELS } from '#/modules/infra/dashboard/helper/dashboardModules';

/**
 * 單一幣別金額：總額＋比例條＋各桶金額／百分比。
 * 桶名稱以 `amounts.keys`（UNINVOICED／UNPAID／PAID、OPEN／CLOSED）對照前端文字，缺 key 時退回後端 `labels`。
 * 不換匯、不跨幣別加總。
 */
const AmountBreakdown = ({ amounts }) => {
  const currencyCode = amounts?.currencyCode ?? '';
  const items = useMemo(() => {
    const keys = amounts?.keys ?? [];
    const labels = amounts?.labels ?? [];
    return (amounts?.series ?? []).map((value, index) => {
      const key = keys[index] ?? labels[index] ?? String(index);
      return {
        key,
        label: AMOUNT_KEY_LABELS[keys[index]] ?? labels[index] ?? key,
        value: Number(value) || 0,
        colorIndex: AMOUNT_KEY_COLOR_INDEX[keys[index]],
      };
    });
  }, [amounts]);

  return (
    <BreakdownSummary
      items={items}
      totalLabel="總額"
      formatValue={(value) => `${currencyCode} ${formatAmount(value)}`}
      emptyText="所選幣別在此區間沒有金額資料。"
    />
  );
};

AmountBreakdown.propTypes = {
  amounts: PropTypes.shape({
    currencyId: PropTypes.string,
    currencyCode: PropTypes.string,
    labels: PropTypes.arrayOf(PropTypes.string),
    keys: PropTypes.arrayOf(PropTypes.string),
    series: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  }).isRequired,
};

export default AmountBreakdown;
